import React, { useEffect, useState, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { X, Camera } from 'lucide-react';

const QRScanner = ({ onScan, onClose }) => {
  const [error, setError] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const scannerRef = useRef(null);
  
  const startScanner = async () => {
    try {
      if (!isScanning && scannerRef.current) {
        setIsScanning(true);
        await scannerRef.current.start(
          { facingMode: "environment" },
          {
            fps: 10,
            qrbox: { width: 250, height: 250 }
          },
          (decodedText) => {
            try {
              const assetData = JSON.parse(decodedText);
              stopScanner();
              onScan(assetData);
            } catch (err) {
              setError('Invalid QR code format');
            }
          },
          (errorMessage) => {
            // Ignore errors during scanning
          }
        );
      }
    } catch (err) {
      console.error('Scanner start error:', err);
      setError('Error accessing camera');
    }
  };

  const stopScanner = async () => {
    try {
      if (scannerRef.current && isScanning) {
        await scannerRef.current.stop();
        setIsScanning(false);
      }
    } catch (err) {
      console.error('Scanner stop error:', err);
    }
  };

  const handleClose = async () => {
    await stopScanner();
    onClose();
  };

  useEffect(() => {
    // Initialize scanner
    scannerRef.current = new Html5Qrcode("qr-reader");
    startScanner();

    // Cleanup function
    return () => {
      stopScanner();
    };
  }, [onScan]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <Camera className="w-5 h-5" />
            Scan QR Code
          </h3>
          <button 
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 rounded-lg"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm flex items-center justify-between">
            <span>{error}</span>
            <button 
              onClick={() => {
                setError(null);
                startScanner();
              }}
              className="ml-2 text-red-700 hover:text-red-800 font-medium"
            >
              Try again
            </button>
          </div>
        )}

        <div className="overflow-hidden rounded-lg bg-gray-100">
          <div 
            id="qr-reader" 
            className="w-full"
            style={{ 
              maxWidth: '600px', 
              margin: '0 auto',
              aspectRatio: '4/3'
            }}
          />
        </div>

        <p className="mt-4 text-sm text-gray-500 text-center">
          Position the QR code within the frame to scan
        </p>
      </div>
    </div>
  );
};

export default QRScanner; 